import Link from "next/link";
import { ComponentPropsWithRef, MouseEvent, PropsWithChildren } from "react";

import ModalManager from "../../../components/Modal/ModalManager";
import { useLocale } from "../contexts/LocaleContext";

type Props = {
  disabled?: boolean;
};

export type LocalizedLinkProps = ComponentPropsWithRef<typeof Link> & Props;

export default function LocalizedLink(
  props: PropsWithChildren<LocalizedLinkProps>
) {
  const { disabled } = props;

  const { locale } = useLocale();

  function handleOnClick(e: MouseEvent<HTMLAnchorElement>) {
    if (!props.target) {
      ModalManager.removeAll();
    }
    props.onClick?.(e);
  }

  return (
    <Link
      {...props}
      style={{
        ...styles.link,
        ...props.style,
        ...(disabled ? styles.disabled : {}),
      }}
      href={`/${locale}/${props.href}`.replaceAll("//", "/")}
      onClick={handleOnClick}
    />
  );
}

const styles = {
  link: {
    textDecoration: "none",
  },
  disabled: {
    pointerEvents: "none" as const,
  },
};
